"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DIALOG_GAP: function() {
        return _constants.DIALOG_GAP;
    },
    DialogContext: function() {
        return _dialogContext.DialogContext;
    },
    DialogProvider: function() {
        return _dialogContext.DialogProvider;
    },
    DialogSurfaceContext: function() {
        return _dialogSurfaceContext.DialogSurfaceContext;
    },
    DialogSurfaceProvider: function() {
        return _dialogSurfaceContext.DialogSurfaceProvider;
    },
    FULLSCREEN_DIALOG_SCROLLBAR_OFFSET: function() {
        return _constants.FULLSCREEN_DIALOG_SCROLLBAR_OFFSET;
    },
    MEDIA_QUERY_BREAKPOINT_SELECTOR: function() {
        return _constants.MEDIA_QUERY_BREAKPOINT_SELECTOR;
    },
    MEDIA_QUERY_SHORT_SCREEN: function() {
        return _constants.MEDIA_QUERY_SHORT_SCREEN;
    },
    SURFACE_BORDER_WIDTH: function() {
        return _constants.SURFACE_BORDER_WIDTH;
    },
    SURFACE_PADDING: function() {
        return _constants.SURFACE_PADDING;
    },
    useDialogContext_unstable: function() {
        return _dialogContext.useDialogContext_unstable;
    },
    useDialogSurfaceContext_unstable: function() {
        return _dialogSurfaceContext.useDialogSurfaceContext_unstable;
    }
});
const _constants = require("./constants");
const _dialogContext = require("./dialogContext");
const _dialogSurfaceContext = require("./dialogSurfaceContext");
